import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import PropTypes from 'prop-types';
import SideNavbar from "../components/SideNavbar";
import Error from "./Error";
import Loading from "./Loading";
import BuckList from "../components/BuckList";

function BuckInventory({ currentProfile, isMobile }) {
    const [selectedSite, setSelectedSite] = useState(null);
    const [bucksObject, setBucksObject] = useState(null);
    const [bucksError, setBucksError] = useState(null);

    const { site } = useParams();
    const navigate = useNavigate();

    let formattedSite = "site";
    if(site) {
        formattedSite = site.replaceAll("-wildlifeinvestments", "");
        let sites = formattedSite.split("-");
        formattedSite = sites.map((word) => {
            return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
        }).join(' ');
    }

    useEffect(() => {
        document.title = `${formattedSite} Buck Inventory`;
    });

    useEffect(() => {
        if(currentProfile && currentProfile.sites) {
            currentProfile.sites.forEach((s) => {
                if(s.slug === site) {
                    setSelectedSite(s);
                }
            });
        }
    }, [currentProfile, site]);

    useEffect(() => {
        if(selectedSite && currentProfile) {
            if(selectedSite.bucksObject) {
                setBucksObject(selectedSite.bucksObject);
            } else {
                selectedSite.getBuckInventory(currentProfile.accessToken).then((response) => {
                    // console.log(response);
                    if(response) {
                        setBucksObject(response);
                    } else {
                        setBucksError('Failed to get latest buck inventory, please refresh the page and try again.')
                    }
                });
            }
        }
    }, [selectedSite, currentProfile]);

    const onDoubleClick = (name) => {
        navigate(`/sites/${site}/inventory/${name}`);
    };

    if(bucksError) {
        return(
            <Error isMobile={isMobile} type={"failure"} text={bucksError} />
        );
    } else if(selectedSite && currentProfile) {
        let sitesURI = "/sites";
        let adminLinks = [];
        let writeLinks = [];
        if(currentProfile.isAdmin) {
            // sitesURI = `/${sub}/sites`;
            adminLinks = [{ "display": "Label Images", "url": `${sitesURI}/${site}/label`}, { "display": "Stats", "url": `${sitesURI}/${site}/stats`}];
        }
        if(selectedSite.access === "write" || selectedSite.access === "owner" || currentProfile.isAdmin) {
            writeLinks = [{ "display": "Image Upload", "url": `${sitesURI}/${site}/upload` }];
        }
        let sideNavbarFilters = [{ "display": "Buck Report", "url": `${sitesURI}/${site}/buck_report` }, { "display": "Buck Inventory", "url": `${sitesURI}/${site}/inventory` }, ...writeLinks, ...adminLinks];

        return (
            <>
                <SideNavbar isMobile={isMobile} propFilters={sideNavbarFilters} title={formattedSite} titleUrl={sitesURI} initialShow={true} />
                <div style={isMobile ? { "minHeight":"92vh" } : { "minHeight":"92vh", "maxWidth": "90%", "display": "flex", "justifyContent": "center" }} className="w3-content w3-container w3-padding-64" id="about">
                    <div style={isMobile ? { "width": "100%" } : { "width": "75%" }}>
                        <div style={{ "display": "flex", "alignItems": "center", "marginBottom": "16px" }}>
                            <h3 style={{ "width": "100%", "margin": "0px" }}>Buck Inventory</h3>
                        </div>
                        <BuckList isMobile={isMobile} bucksObject={bucksObject} onDoubleClick={onDoubleClick} />
                    </div>
                </div>
            </>
        );
    } else if(!currentProfile && typeof currentProfile === "boolean") {
        return(
            <Error isMobile={isMobile} type={"login"} />
        );
    } else {
        return(
            <Loading isMobile={isMobile} text={`${formattedSite}`} />
        );
    }
}

BuckInventory.propTypes = {
    dataView: PropTypes.bool,
    isMobile: PropTypes.bool,
    currentProfile: PropTypes.object
};

export default BuckInventory;